<template>
  <transition name="fade">
    <main role="main">
      <section>
        <div class="info-plan">
          <div class="info-plan__flight" v-if="flightInfo.number">
            <h2>
              {{ $t("flight-info.flight") }}
            </h2>
            <p>{{ flightInfo.number }}</p>
          </div>

          <div class="info-plan__aircraft">
            <h2>
              {{ $t("flight-info.aircraft") }}
            </h2>
            <!-- <p>Airbus A321-200NX (NEO)</p> -->
          </div>

          <div class="info-plan__departure">
            <h2>
              {{ $t("flight-info.departure") }}
            </h2>
            <p class="info-plan__departure-arrival_name">
              {{ flightInfo.legs[0].origin[$i18n.locale].city }}
            </p>
            <div class="info-plan__departure-arrival__schedule">
              <div>
                <svg 
                  width="18"
                  height="25"
                  viewBox="0 0 18 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <use href="../../assets/img/map/info-plan/geolocation.svg#geo"></use>
                </svg>
              </div>
              <span class="info-plan__departure-arrival__schedule_head">
                {{ flightInfo.legs[0].origin[$i18n.locale].name }} ({{
                  flightInfo.legs[0].origin[$i18n.locale].iata
                }})
              </span>
            </div>
            <div
              class="info-plan__departure-arrival__schedule"
              v-if="flightInfo.legs[0].depTimeFactLocal"
            >
              <svg
                class="d-none"
                width="22"
                height="24"
                viewBox="0 0 22 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use href="../../assets/img/map/info-plan/calendar-days.svg#calendar"></use>
              </svg>
              <span>
                {{ normaliseDate(flightInfo.legs[0].depTimeFactLocal) }}</span
              >
            </div>
            <div
              class="info-plan__departure-arrival__schedule"
              v-if="flightInfo.legs[0].depTimeFactLocal"
            >
              <svg
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use href="../../assets/img/map/info-plan/clock.svg#clock"></use>
              </svg>
              <span>
                {{ getTimeFromDate(flightInfo.legs[0].depTimeFactLocal) }} GMT
                {{ getTimeZoneFromDate(flightInfo.actualLocalTz) }}
              </span>
            </div>
          </div>

          <!-- <div class="info-plan__arrival"> -->
            <div class="info-plan__arrival info-plan__departure info-plan__departure-arrival">
              <h2>
                {{ $t("flight-info.arrival") }}
              </h2>
              <p class="info-plan__departure-arrival_name">
                {{ flightInfo.legs[0].destination[$i18n.locale].city }}
              </p>
              <div class="info-plan__departure-arrival__schedule">
                <div>
                  <svg 
                  width="18"
                  height="25"
                  viewBox="0 0 18 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <use href="../../assets/img/map/info-plan/geolocation.svg#geo"></use>
                </svg>
                </div>
                <div>
                  <span class="info-plan__departure-arrival__schedule_head">
                    {{ flightInfo.legs[0].destination[$i18n.locale].name }} ({{
                      flightInfo.legs[0].destination[$i18n.locale].iata
                    }})
                  </span>
                </div>
              </div>
              <div
                class="info-plan__departure-arrival__schedule"
                v-if="flightInfo.legs[0].arrTimeFactLocal"
              >
              <svg
                class="d-none"
                width="22"
                height="24"
                viewBox="0 0 22 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use href="../../assets/img/map/info-plan/calendar-days.svg#calendar"></use>
              </svg>
                <span>
                  {{ normaliseDate(flightInfo.legs[0].arrTimeFactLocal) }}</span
                >
              </div>
              <div
                class="info-plan__departure-arrival__schedule"
                v-if="flightInfo.legs[0].arrTimeFactLocal"
              >
              <svg
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use href="../../assets/img/map/info-plan/clock.svg#clock"></use>
              </svg>
                <span>
                  {{ getTimeFromDate(flightInfo.legs[0].arrTimeFactLocal) }} GMT
                  {{ getTimeZoneFromDate(flightInfo.arrivalDateLocalTz) }}
                </span>
              </div>
            </div>
          <!-- </div> -->

          <div class="info-plan__air">
            <picture>
              <source
                media="(max-width:414px)"
                srcset="@/assets/img/map/info-plan/plane-mobile.png"
              />
              <source
                media="(max-width:1023px)"
                srcset="@/assets/img/map/info-plan/plane-small.png"
              />
              <img
                src="@/assets/img/map/info-plan/plane-big.png"
                alt="самолёт"
              />
            </picture>
          </div>

          <div class="info-plan__data">
            <h2>{{ $t("flight-info.flight-parameters") }}</h2>
            <div class="info-plan__data__wrapper">
              <div class="info-plan__data__col">
                <svg
                    width="30"
                    height="31"
                    viewBox="0 0 30 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <use
                    href="../../assets/img/map/info-plan/clouds.svg#clouds">
                  </use>
                </svg>
                <p class="info-plan__data__col_left">{{ currentAlt }}</p>
              </div>
              <div class="info-plan__data__col">
                <p class="info-plan__data__col_right color-name">
                  {{ $t("flight-info.altitude") }}
                </p>
                <div class="ellipsis"></div>
                <p class="info-plan__data__col_right color-data">
                  {{ $t("flight-info.m") }}
                </p>
              </div>

              <div class="info-plan__data__col">
                <svg
                    width="30"
                    height="31"
                    viewBox="0 0 30 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <use 
                    href="../../assets/img/map/info-plan/speed.svg#speed"
                  >
                  </use>
                </svg>
                <p class="info-plan__data__col_left">{{ currentSpeed }}</p>
              </div>
              <div class="info-plan__data__col">
                <p class="info-plan__data__col_right color-name">
                  {{ $t("flight-info.speed") }}
                </p>
                <div class="ellipsis"></div>
                <p class="info-plan__data__col_right color-data">
                  {{ $t("flight-info.speedUnit") }}
                </p>
              </div>

              <div class="info-plan__data__col">
                <svg
                    width="30"
                    height="31"
                    viewBox="0 0 30 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <use 
                    href="../../assets/img/map/info-plan/time.svg#time"
                  >
                  </use>
                </svg>
                <p class="info-plan__data__col_left">{{ currentTimeToDestination }}</p>
              </div>
              <div class="info-plan__data__col">
                <p class="info-plan__data__col_right color-name">
                  {{ $t("flight-info.timeLeft") }}
                </p>
                <div class="ellipsis"></div>
                <p class="info-plan__data__col_right color-data">
                  <!-- {{ currentHdg }}&deg; -->
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="info-plan__mendeleev">
            <h2>БОРТ</h2>
            <p class="info-plan__mendeleev_head">«Дмитрий Менделеев»</p>
            <p class="info-plan__mendeleev_description">
              Борт носит имя русского химика, учёного-энциклопедиста, педагога и
              общественного деятеля Дмитрия Ивановича Менделеева
            </p>
            <div class="info-plan__mendeleev__bth">
              <button>
                {{ $t("crew.details") }}
              </button>
            </div>
          </div> -->
        </div>
      </section>
    </main>
  </transition>
</template>

<script>
import { mapState } from "vuex";
import flight from "@/mixins/flight";

export default {
  name: "PlaneInfo",
  created() {
    this.getFlightInfo();
    // window.addEventListener("resize", onResize);
  },
  beforeDestroy() {
    clearInterval(this.intervalid);
    window.removeEventListener("resize", this.onResize);
  },
  mixins: [flight],
  methods: {
    getDirection(degrees) {
      const directions = [
        "N",
        "NNE",
        "NE",
        "ENE",
        "E",
        "ESE",
        "SE",
        "SSE",
        "S",
        "SSW",
        "SW",
        "WSW",
        "W",
        "WNW",
        "NW",
        "NNW",
        "N", // Добавляем 'N' в конец для корректной работы с 360 градусами
      ];
      const index = Math.round((degrees % 360) / 22.5); // Делим на 22.5, т.к. 360 градусов / 16 направлений = 22.5 градуса на каждое направление
      return directions[index];
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
    }),
    currentAlt() {
      return this.flightInfo.altitude;
    },
    currentSpeed() {
      return this.flightInfo.groundSpeed;
    },
	currentTimeToDestination() {
		return this.flightInfo.timeToDestination;
	},
    currentHdg() {
      if (
        this.flightInfo.trueHeading < 0 ||
        this.flightInfo.trueHeading > 360
      ) {
        return 0;
      } else {
        return this.flightInfo.trueHeading;
      }
    },
    currentHdgTxt() {
      return this.flightInfo.trueHeadingName
        ? this.flightInfo.trueHeadingName[this.$i18n.locale]
          ? this.flightInfo.trueHeadingName[this.$i18n.locale]
          : this.flightInfo.trueHeadingName.en
        : this.getDirection(this.currentInfo.currentHdg);
    },
  },
};
</script>

<style scoped></style>
